import {createRootContextHook} from 'common/util/react';
import {i18next} from 'common/i18n';
import {LocalizationStore} from 'common/i18n/store';

/**
 * A hook that re-renders the component when the current language changes.
 */
export const useTranslation = createRootContextHook(`i18n`);

/**
 * Falls back to a store on the shared `i18next` instance when rendered outside a context root.
 *
 * @public
 */
export const useTranslationWithFallback = createRootContextHook(`i18n`, () => new LocalizationStore(i18next));
